<template>
  <main-layout>
    <form-layout>
      <el-form
        v-if="form"
        :model="form"
        :rules="rules"
        label-width="150px"
        style="width: 400px; margin: 0 auto"
        ref="form"
      >
        <el-form-item>
          <div>{{ $t('quicktech_login_tip') }}</div>
        </el-form-item>
        <el-form-item prop="mobile" :label="$t('mobile')">
          <el-input v-model="form.mobile"></el-input>
        </el-form-item>
        <el-form-item prop="captcha" :label="$t('captcha')">
          <div class="flex-box">
            <el-input v-model="form.captcha"></el-input>
            <el-button
              :disabled="!form.mobile || !!captchaCounter"
              type="primary"
              @click="sendCaptcha"
            >
              {{ captchaCounter ? `${captchaCounter}s` : '发送' }}
            </el-button>
          </div>
        </el-form-item>
        <template v-if="mode === 'login' && !user">
          <el-form-item>
            <el-button type="primary" style="width: 100%" @click="doLogin">
              {{ $t('login') }}
            </el-button>
          </el-form-item>
        </template>
        <template v-if="mode === 'register'">
          <el-form-item prop="password" :label="$t('password')">
            <el-input v-model="form.password" show-password></el-input>
          </el-form-item>
          <el-form-item prop="password2" :label="$t('new_password2')">
            <el-input v-model="form.password2" show-password></el-input>
          </el-form-item>
          <el-form-item prop="companyName" :label="$t('company_name')">
            <el-input v-model="form.companyName"></el-input>
          </el-form-item>
          <el-form-item :label="$t('real_name')" style="margin-bottom: 0">
            <div class="flex-box">
              <el-form-item :error="errors.lastName" prop="lastName_zh">
                <el-input
                  v-model="form.lastName"
                  :placeholder="$t('last_name')"
                ></el-input>
              </el-form-item>
              <el-form-item :error="errors.firstName" prop="firstName_zh">
                <el-input
                  v-model="form.firstName"
                  :placeholder="$t('first_name')"
                ></el-input>
              </el-form-item>
            </div>
          </el-form-item>
          <el-form-item
            :error="errors.jobTitle"
            :label="$t('job_title')"
            prop="jobTitle"
          >
            <el-input v-model="form.jobTitle" class="el-input--wmd"></el-input>
          </el-form-item>
          <el-form-item :error="errors.email" :label="$t('email')" prop="email">
            <el-input v-model="form.email" class="el-input--wmd"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" style="width: 100%" @click="doRegister">
              {{ $t('register') }}
            </el-button>
          </el-form-item>
        </template>
      </el-form>
    </form-layout>
  </main-layout>
</template>

<script>
import { lengthValidator, emailValidator } from '@/utils/validators';
import MainLayout from '@/components/layout/main';
import FormLayout from '@/components/layout/form';

export default {
  name: 'Personal',
  components: {
    MainLayout,
    FormLayout,
  },
  props: {},
  data() {
    return {
      mode: '',
      form: null,
      emptyForm: {
        mobile: '',
        captcha: '',
        password: '',
        password2: '',
        lastName: '',
        firstName: '',
        companyName: '',
        jobTitle: '',
        email: '',
      },
      errors: {
        mobile: null,
        captcha: null,
        password: null,
        password2: null,
        lastName: null,
        firstName: null,
        companyName: null,
        jobTitle: null,
        email: null,
      },
      loadingCount: 0,
      isAgreed: false,
      captchaCounter: 0,
      counterTimer: null,
    };
  },
  computed: {
    user() {
      return this.$store.state.user?.profile;
    },
    rules() {
      return {
        mobile: [
          {
            required: true,
          },
        ],
        captcha: [
          {
            required: true,
          },
        ],
        password: [
          {
            required: true,
          },
        ],
        password2: [
          {
            required: true,
          },
          {
            validator: (rule, value, callback) => {
              if (value === '') {
                callback(new Error('请再次输入密码'));
              } else if (value !== this.form.password) {
                callback(new Error('两次输入密码不一致!'));
              } else {
                callback();
              }
            },
          },
        ],
        lastName: [
          {
            required: true,
          },
          {
            validator: lengthValidator,
            min: 1,
            max: 20,
            trigger: 'change',
          },
        ],
        firstName: [
          {
            required: true,
          },
          {
            validator: lengthValidator,
            min: 1,
            max: 20,
            trigger: 'change',
          },
        ],
        companyName: [
          {
            required: true,
          },
          {
            validator: lengthValidator,
            min: 1,
            max: 50,
            trigger: 'change',
          },
        ],
        jobTitle: [
          {
            required: true,
          },
          {
            validator: lengthValidator,
            min: 1,
            max: 20,
            trigger: 'change',
          },
        ],
        email: [
          {
            required: true,
          },
          {
            validator: emailValidator,
            min: 1,
            max: 50,
            trigger: 'change',
          },
        ],
      };
    },
  },
  watch: {},
  methods: {
    startCounter() {
      this.captchaCounter = 60;
      clearInterval(this.counterTimer);
      this.counterTimer = setInterval(() => {
        this.captchaCounter--;
        if (this.captchaCounter === 0) {
          clearInterval(this.counterTimer);
        }
      }, 1000);
    },
    sendCaptcha() {
      if (!this.form.mobile || this.captchaCounter > 0) return;

      if (!this.mode || this.mode === 'login') {
        this.$axios
          .get('login/captcha/' + this.form.mobile)
          .then(({ data }) => {
            if (data.user) {
              this.mode = 'login';
              this.startCounter();
            } else {
              this.mode = 'register';
              this.sendCaptcha();
            }
          });
      } else {
        this.$axios
          .get('register/captcha/' + this.form.mobile)
          .then(({ data }) => {
            this.mode = 'register';
            this.startCounter();
          })
          .catch(e => {
            if (e.message[0] === 'registered') {
              this.mode = 'login';
              this.sendCaptcha();
            }
          });
      }
    },
    doLogin() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loadingCount++;
          this.$store
            .dispatch('user/login', {
              mobile: this.form.mobile,
              captcha: this.form.captcha,
            })
            .then(() => {
              this.$store.commit('selfUpload/setCompanyProfile', {
                name: this.user.company.name_zh,
              });
              this.$router.push('/company-profile');
            })
            .catch(({ message, errors }) => {
              this.$notify.error({
                title: this.$t('operation_failed'),
                message: this.$t('failed_login'),
              });
              this.setErrors(errors);
            })
            .then(() => {
              this.loadingCount--;
            });
        }
      });
    },
    doRegister() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.$store.dispatch('user/register', this.form).then(() => {
            this.$store.commit('selfUpload/setCompanyProfile', {
              name: this.user.company.name_zh,
            });
            this.$router.push('/company-profile');
          });
        }
      });
    },
    setErrors(errors) {
      if (errors) {
        for (let i = 0; i < errors.length; i++) {
          let error = errors[i];
          if (typeof error === 'string') {
            error = {
              name: error,
              error: ['error'],
            };
          }
          const [text, values] = error.error || [error.message, []];
          this.errors[error.path] = this.$t(text, values || undefined);
        }
      }
    },
    resetErrors() {
      Object.keys(this.errors).forEach(value => {
        if (this.errors[value] instanceof Array) {
          this.errors[value] = this.errors[value].map(() => null);
        } else {
          this.errors[value] = null;
        }
      });
    },
    submit() {
      this.resetErrors();
      this.$refs.form.validate(formValid => {
        if (formValid) {
          this.next();
        } else {
          this.$notify.error({
            title: this.$t('operation_failed'),
            message: this.$t('validation_failed'),
          });
        }
        return formValid;
      });
    },
    next() {
      this.$router.push('/company-profile');
    },
  },
  created() {
    if (this.$store.state.user.profile) {
      this.$store.commit('selfUpload/setCompanyProfile', {
        name: this.user.company.name_zh,
      });
      this.next();
    } else {
      const form = Object.assign({}, this.emptyForm);
      this.form = form;
    }
  },
};
</script>
